// src/constants/permissions.js

export const PERMISSIONS = {
  USERS: {
    VIEW: "users.view",
    CREATE: "users.create",
    EDIT: "users.edit",
    DELETE: "users.delete",
    ROLE_ASSIGN: "users.role_assign",
    SUSPEND: "users.suspend",
  },

  ROLES: {
    VIEW: "roles.view",
    CREATE: "roles.create",
    EDIT: "roles.edit",
    DELETE: "roles.delete",
    ASSIGN: "roles.assign",
  },
};

export default PERMISSIONS;